import { render, staticRenderFns } from "./PartnershipDetail.vue?vue&type=template&id=2044c0b8&"
import script from "./PartnershipDetail.vue?vue&type=script&lang=js&"
export * from "./PartnershipDetail.vue?vue&type=script&lang=js&"
import style0 from "./PartnershipDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports